/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

// HOME PAGE

function isInViewport(element) {
  const rect = element.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

function FnGo(item, index) {
  let id = item.getAttribute('aria-controls');

  item.addEventListener('click', (event) => {

    event.preventDefault();
    let modal = document.querySelector('#' + id);
    let vid = modal.querySelector('video');
    let iframe = modal.querySelector('iframe');
    if (vid) {
      vid.play();
    }
    if (iframe) {
      iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
    }

  });
}

function FnModal(item, index) {
  let close = item.querySelector('[data-action="close"]');
  close.addEventListener('click', function(){

    let modalVideos = document.querySelectorAll('.modal-video');
    modalVideos.forEach(function(item, index) {

      let vid = item.querySelector('video');
      let iframe = item.querySelector('iframe');

      if (vid) {
        vid.pause();
      }
      if (iframe) {
        iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
      }

    });

  });
}

function FnArticles(item, index) {

  var ul = document.querySelectorAll("ul.indicator");
  var li = document.querySelectorAll("ul.indicator li");

  if (isInViewport(item)) {

    li.forEach(function(i, x) {
      if (x == index) {
        i.classList.add("active");
      } else {
        i.classList.remove("active");
      }
    });

  }

}

const playButton = document.querySelectorAll('.btn-play-video[aria-controls]');
playButton.forEach(FnGo);

window.addEventListener('DOMContentLoaded', () => {

  const modals = document.querySelectorAll('.modal-video');
  modals.forEach(FnModal);

  const articles = document.querySelectorAll('.article-list.article-list--scrollable .article-item');

  // articles.forEach(FnArticles);

});

document.querySelectorAll(".shopify-section--blog-posts .scroller").forEach(function(item, index) {

  item.addEventListener("scroll", function(e) {
    const articles = document.querySelectorAll('.article-list.article-list--scrollable .article-item');
    articles.forEach(FnArticles);
  });
});

// PRODUCT PAGE
// Declare a fragment:
var fragment = document.createDocumentFragment();
var qty = document.querySelector('.product-form__quantity');
var btns = document.querySelector('.product-form__buy-buttons');
var el = document.querySelector('#quantity-buy-selector');
if (qty && btns && el) {
  fragment.appendChild(qty);
  fragment.appendChild(btns);
  // Append fragment to desired element:
  el.appendChild(fragment);
}

// PRODUCTS
function getActiveSubs(el) {
  var elementExists = el.querySelector(".rc-radio__price");
  if (elementExists) {
    var price = el.querySelector('.rc-radio__price').innerHTML;
    var price = price.replace(' ', '');
  } else {
    var price = el.querySelector('.rc-radio__label').innerHTML;
    var price = price.replace('One-time purchase ', '');
  }
  return price.replace('A$', '$');
}
function FnPricing() {
  var el = document.querySelector('.rc-widget');

  if (el) {

    var orig = el.querySelector('.onetime-radio');
    el.addEventListener('click', e => {
      var el = e.target.closest('label.rc-radio');
      if (getActiveSubs(el) != getActiveSubs(orig)) {
        document.querySelector('.product__info .price-list').innerHTML = `<span class="price price--large">${getActiveSubs(el)}</span><strike>${getActiveSubs(orig)}</strike>`;
      } else {
        document.querySelector('.product__info .price-list').innerHTML = `<span class="price price--large">${getActiveSubs(el)}</span>`;
      }
    });

  }

}
(function() {
  var state = document.readyState;
  if(state === 'complete' && typeof template != 'undefined') {
    if (template == "product") {
      FnPricing();
    }
  }
  else setTimeout(arguments.callee, 200);
})();

// REMOVE PARENT TAG
function htmlDecode(input) {
  var doc = new DOMParser().parseFromString(input, "text/html");
  return doc.documentElement.textContent;
}

// METAFIELD HTML DECODE
function unwrap(wrapper) {
  // place childNodes in document fragment
  var docFrag = document.createDocumentFragment();
  while (wrapper.firstChild) {
    var child = wrapper.removeChild(wrapper.firstChild);
    docFrag.appendChild(child);
  }

  // replace wrapper with document fragment
  wrapper.parentNode.replaceChild(docFrag, wrapper);
}

// REMOVE OUTER P
document.querySelectorAll(".product-tabs__tab-item-content > p").forEach(function (item) {
  // unwrap(item);
});

// DECODE HTML
document.querySelectorAll(".product-tabs__tab-item-content .metafield-multi_line_text_field").forEach(function (item) {
  // item.innerHTML = htmlDecode(item.innerHTML);
});

function selectCurrency(val) {
  document.querySelector('#header-localization-form [name=country_code]').value = val;
  document.querySelector('#header-localization-form').submit()
}

// change variant on image click
// document.querySelectorAll("button[data-variant-id]").forEach(function (item) {
//   console.log(item);
//   item.addEventListener('click', e => {
//     const el = e.target.closest('button');
//     const variant_id = parseInt(el.getAttribute('data-variant-id'));
//
//     if (variant_id) {
//       const productVariantElement = document.querySelector('product-variants');
//       productVariantElement.selectVariant(variant_id);
//     }
//   });
// });


// ABOUT US PAGE
// Wrap an HTMLElement around each element in an HTMLElement array.
/*
HTMLElement.prototype.wrap = function(elms) {
    // Convert `elms` to an array, if necessary.
    if (!elms.length) elms = [elms];

    // Loops backwards to prevent having to clone the wrapper on the
    // first element (see `child` below).
    for (var i = elms.length - 1; i >= 0; i--) {
        var child = (i > 0) ? this.cloneNode(true) : this;
        var el    = elms[i];

        // Cache the current parent and sibling.
        var parent  = el.parentNode;
        var sibling = el.nextSibling;

        // Wrap the element (is automatically removed from its current
        // parent).
        child.appendChild(el);

        // If the element had a sibling, insert the wrapper before
        // the sibling to maintain the HTML structure; otherwise, just
        // append it to the parent.
        if (sibling) {
            parent.insertBefore(child, sibling);
        } else {
            parent.appendChild(child);
        }
    }
};

var one = document.getElementById('shopify-section-template--14763089592435__1657675135da05d42f');
var two = document.getElementById('shopify-section-template--14763089592435__165767614310ceb285').outerHTML;

if (one && two) {

  // create wrapper
  var wrapper = document.createElement('div');
  wrapper.setAttribute('id', 'custom-wrapper');

  // wrap div 1
  wrapper.wrap(one);
  // insert div 2 after div 1
  one.insertAdjacentHTML("afterend", two);

  // remove outer div 2
  document.querySelector('#main > #shopify-section-template--14763089592435__165767614310ceb285').remove();

}

*/

// if(template == "product"){
//   const queryString = window.location.search;
//   const urlParams = new URLSearchParams(queryString);
//   const selectedPlan = urlParams.get('selling_plan')
//   const priceSelector = document.querySelector(".product-meta__price-list-container .price");
//   sellingPlans.forEach(plan => {
//     if(plan.id == selectedPlan){
//       const priceAdjustments = plan.price_adjustments;
//       const discount = priceAdjustments[0].value / 100;
//       const currentPrice = parseFloat(priceSelector.innerText.split("$")[1]);
//       const discounted = (currentPrice - (currentPrice * discount)).toFixed(2);
//       document.querySelector(".product-meta__price-list-container .price").innerHtml = `<span class="visually-hidden">Sale price</span> $${discounted}`
//     }
//   })
// }
